/* Flashark YMME v4: one complete variant metafield value per fitment tuple. */
(function (window) {
  'use strict';

  const FIELDS = ['year', 'make', 'model', 'engine'];
  const PARAM = 'filter.v.m.custom.ymme_data';
  const RANGE = /^(\d{4})\s*[-–—]\s*(\d{4})$/;
  const text = (value) => String(value == null ? '' : value).trim();
  const key = (value) => text(value).toLocaleLowerCase();

  function complete(vehicle) {
    return FIELDS.every((field) => text(vehicle && vehicle[field]));
  }

  function parse(value) {
    const parts = text(value).split('|').map(text);
    if (parts.length !== 4 || parts.some((part) => !part)) return null;
    return { raw: text(value), year: parts[0], make: parts[1], model: parts[2], engine: parts[3] };
  }

  function match(value, vehicle) {
    const fitment = typeof value === 'string' ? parse(value) : value;
    if (!fitment || !complete(vehicle)) return false;
    if (key(fitment.make) !== key(vehicle.make) || key(fitment.model) !== key(vehicle.model) || key(fitment.engine) !== key(vehicle.engine)) return false;
    if (fitment.year === text(vehicle.year)) return true;
    const range = fitment.year.match(RANGE);
    const year = Number(vehicle.year);
    return Boolean(range && Number.isFinite(year) && year >= Number(range[1]) && year <= Number(range[2]));
  }

  function values(value) {
    if (Array.isArray(value)) return value.map(text).filter(Boolean);
    if (typeof value === 'string') {
      try { const parsed = JSON.parse(value); return Array.isArray(parsed) ? parsed.map(text).filter(Boolean) : [text(value)].filter(Boolean); } catch (_) { return [text(value)].filter(Boolean); }
    }
    return [];
  }

  function matchAny(fitments, vehicle) {
    return values(fitments).some((fitment) => match(fitment, vehicle));
  }

  function canonical(vehicle) {
    return complete(vehicle) ? `${text(vehicle.year)}|${text(vehicle.make)}|${text(vehicle.model)}|${text(vehicle.engine)}` : '';
  }

  function filterValues(vehicle, knownValues) {
    const exact = canonical(vehicle);
    if (!exact) return [];
    const found = [exact];
    values(knownValues).forEach((item) => {
      if (match(item, vehicle) && !found.includes(item)) found.push(item);
    });
    return found;
  }

  function buildCollectionUrl(href, vehicle, knownValues) {
    const url = new URL(href || '/collections/all', window.location.origin);
    url.searchParams.delete(PARAM);
    // Old query values are removed so Shopify does not apply the obsolete filters.
    ['filter.v.m.custom.ymme_year', 'filter.v.m.custom.ymme_make', 'filter.v.m.custom.ymme_model', 'filter.v.m.custom.ymme_engine'].forEach((name) => url.searchParams.delete(name));
    filterValues(vehicle, knownValues).forEach((value) => url.searchParams.append(PARAM, value));
    return url;
  }

  window.FlasharkYmme = Object.assign(window.FlasharkYmme || {}, {
    fields: FIELDS,
    param: PARAM,
    complete,
    parse,
    match,
    matchAny,
    values,
    canonical,
    filterValues,
    buildCollectionUrl
  });
})(window);
